import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckIcon from "@mui/icons-material/Check";
import AppDialog from "~/shared/ui/AppDialog";
import { PersonAvatar } from "../../shared/StatePanels";
import { roleOptionLabel } from "../labels";
import { consequencesText } from "./stagedChanges";
import { COLORS } from "~/ui/tokens";

const titleFor = (count) => (count === 1 ? "Salvar 1 alteração?" : `Salvar ${count} alterações?`);

export default function ConfirmChangesDialog({ open, count, items, saving, error, onBack, onConfirm }) {
  return (
    <AppDialog
      open={open}
      onClose={onBack}
      busy={saving}
      size="sm"
      title={titleFor(count)}
      context="Confira antes de gravar. Cada alteração entra na auditoria com seu nome."
      actions={
        <>
          <Button onClick={onBack} disabled={saving} sx={{ color: "text.primary" }}>Voltar</Button>
          <LoadingButton variant="contained" startIcon={<CheckIcon />} loading={saving} onClick={onConfirm}>Confirmar e salvar</LoadingButton>
        </>
      }
    >
      <Box sx={{ border: "1px solid #e5e7eb", borderRadius: 1 }}>
        {items.map((item) => (
          <Box key={item.user.id} sx={{ display: "flex", gap: 1.5, alignItems: "center", p: 1.5, "& + &": { borderTop: "1px solid #e5e7eb" } }}>
            <PersonAvatar name={item.user.name} email={item.user.email} size={30} />
            <Box sx={{ flexGrow: 1 }}>
              <Typography sx={{ fontWeight: 600 }}>{item.user.name || item.user.email}</Typography>
              {item.role && <Typography variant="body2" sx={{ color: COLORS.muted }}>Papel Antecipe</Typography>}
              {(item.add.length > 0 || item.remove.length > 0) && <Typography variant="body2" sx={{ color: COLORS.muted }}>Gestor das empresas</Typography>}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.5 }}>
              {item.role && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography component="s" variant="body2" sx={{ color: COLORS.muted }}>{roleOptionLabel(item.role.from)}</Typography>
                  <ArrowForwardIcon fontSize="small" sx={{ color: COLORS.muted }} aria-label="para" />
                  <Typography sx={{ fontWeight: 600 }}>{roleOptionLabel(item.role.to)}</Typography>
                </Box>
              )}
              {item.add.map((name) => <Chip key={`a-${name}`} size="small" label={`+ ${name}`} sx={{ bgcolor: "#e8f5e9", color: "#2e7d32" }} />)}
              {item.remove.map((name) => <Chip key={`r-${name}`} size="small" label={`− ${name}`} sx={{ bgcolor: "#fdecea", color: "#d32f2f" }} />)}
            </Box>
          </Box>
        ))}
      </Box>
      <Alert severity="info" sx={{ mt: 2 }}>{consequencesText(items)}</Alert>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </AppDialog>
  );
}
